import { Alert } from "@/components/ui/Alert";
import { AlertCircle, Package, RefreshCw } from "lucide-react";

type ModelStatusProps =
  | { kind: "loading" }
  | { kind: "error"; message: string; onRetry: () => void }
  | { kind: "empty"; filtered: boolean };

export function ModelStatus(props: ModelStatusProps) {
  if (props.kind === "loading") {
    return (
      <div className="flex items-center justify-center h-32">
        <div className="w-8 h-8 border-2 border-sands-300 border-t-sands-600 rounded-full animate-spin" />
      </div>
    );
  }

  if (props.kind === "error") {
    return (
      <div className="flex flex-col items-center justify-center h-32 gap-3 p-4">
        <AlertCircle className="w-8 h-8 text-destructive/60" />
        <Alert
          variant="destructive"
          className="text-center border-0 bg-transparent p-0"
        >
          {props.message}
        </Alert>
        <button
          onClick={props.onRetry}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-sands-600 bg-sands-100 hover:bg-sands-200 rounded-lg transition-colors"
        >
          <RefreshCw className="w-3 h-3" />
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-32 gap-2">
      <Package className="w-8 h-8 text-sands-300" />
      <p className="text-sm text-sands-400">
        {props.filtered ? "No models match your search" : "No models available"}
      </p>
      <p className="text-[10px] text-sands-400">
        Drag a model into the scene to place it
      </p>
    </div>
  );
}
